import React, { Component } from 'react';
import ReactDOM from 'react-dom';
import PropTypes from 'prop-types';
import onClickOutside from 'react-onclickoutside';
import ModalTrigger from './ModalTrigger';

export class OrgCommunitySelector extends Component {
  static propTypes = {
    organizations: PropTypes.arrayOf(
      PropTypes.shape({
        name: PropTypes.string.isRequired,
        slug: PropTypes.string.isRequired,
        logo: PropTypes.string.isRequired,
        canAddCommunities: PropTypes.bool,
        communities: PropTypes.arrayOf(
          PropTypes.shape({
            name: PropTypes.string.isRequired,
            slug: PropTypes.string.isRequired,
            logo: PropTypes.string.isRequired,
            url: PropTypes.string.isRequired,
          })
        ).isRequired,
      })
    ).isRequired,
    isStaff: PropTypes.bool.isRequired,
    newCommunityUrl: PropTypes.string,
    navbarCollapsed: PropTypes.bool.isRequired,
    canOpenSelector: PropTypes.bool.isRequired,
    activeCommunity: PropTypes.object,
    unionLogo: PropTypes.string.isRequired,
  };

  static defaultProps = {
    newCommunityUrl: '',
    activeCommunity: null,
  };

  constructor(props) {
    super(props);

    this.state = {
      organizations: props.organizations.reduce((oAcc, oItem) => {
        if (oItem.communities.length > 0) {
          oAcc[oItem.slug] = Object.assign({}, oItem, {
            expanded: oItem.communities.some((c) => c.active),
            logo: oItem.logo !== null ? oItem.logo : this.props.unionLogo,
            communities: oItem.communities.reduce((cAcc, cItem) => {
              cAcc.push(cItem);
              return cAcc;
            }, []),
          });
        }
        return oAcc;
      }, {}),
      selectorExpanded: false,
      newCommunityModalVisible: false,
      activeCommunity: props.activeCommunity,
    };
  }

  handleClickOutside = () => {
    if (this.state.selectorExpanded && document.querySelector('.create-community-modal') === null) {
      this.setState({ selectorExpanded: false });
    }
  };

  handleOrganizationClick(slug) {
    const organizations = Object.assign({}, this.state.organizations);
    organizations[slug].expanded = !organizations[slug].expanded;

    this.setState({ organizations });
  }

  handleTriggerClick = () => {
    if (this.props.canOpenSelector) {
      this.setState({ selectorExpanded: !this.state.selectorExpanded });
    }
  };

  renderTrigger() {
    return (
      <div
        onClick={this.handleTriggerClick}
        className={`org-community-selector-trigger ${
          this.props.canOpenSelector ? 'u-cursor-pointer' : ''
        }`}>
        {this.state.activeCommunity !== null && (
          <div className="u-flex u-items-center u-relative u-w-full u-h-full">
            <div className="org-community-selector-trigger-logo">
              <img src={this.state.activeCommunity.logo} alt="" />
            </div>
            {!this.props.navbarCollapsed && (
              <div className="u-flex u-items-center u-max-w-1/2">
                <span className="u-text-old-even-darker-grey u-font-semibold u-truncate">
                  {this.state.activeCommunity.name}
                </span>
                {this.props.canOpenSelector && (
                  <span className="org-community-selector-trigger-icon">
                    <i
                      className={`u-text-old-even-darker-grey Icon ${
                        this.state.selectorExpanded ? 'Icon-chevron-up' : 'Icon-chevron-down'
                      }`}></i>
                  </span>
                )}
              </div>
            )}
          </div>
        )}
        {this.state.activeCommunity === null && (
          <div className="u-flex u-items-center">
            <div className="u-h-8 u-w-8 u-mx-4 u-p-2 u-rounded u-border u-border-grey u-flex-shrink-0">
              <img src={this.props.unionLogo} alt="" />
            </div>
            {!this.props.navbarCollapsed && (
              <div className="u-flex u-items-center u-max-w-2/3">
                <span className="u-truncate">Go back to</span>
                <span className="org-community-selector-trigger-icon">
                  <i
                    className={`Icon ${
                      this.state.selectorExpanded ? 'Icon-chevron-up' : 'Icon-chevron-down'
                    }`}></i>
                </span>
              </div>
            )}
          </div>
        )}
      </div>
    );
  }

  renderSelector() {
    return (
      <div className="org-community-selector-list">
        <ul className="u-m-0">
          {Object.values(this.state.organizations).map((organization, index) => {
            return (
              <li
                key={organization.slug}
                className={`org-community-selector-list-item org-community-selector-list-item--org u-flex-col u-justify-between ${
                  index < Object.values(this.state.organizations).length - 1 ? 'u-border-b' : ''
                }`}>
                <div
                  className="u-flex u-items-center u-justify-between u-cursor-pointer u-py-2"
                  onClick={() => this.handleOrganizationClick(organization.slug)}>
                  <div className="u-flex u-items-center u-max-w-5/6">
                    <img
                      src={organization.logo}
                      alt=""
                      className="org-community-selector-list-item-logo"
                    />
                    <div className="u-flex u-flex-col u-truncate">
                      <span className="org-community-selector-list-item-title">
                        {organization.name}
                      </span>
                      <span className="org-community-selector-list-item-subtitle">
                        Organization
                      </span>
                    </div>
                  </div>
                  <i
                    className={`u-text-black u-ml-2 u-mr-4 Icon ${
                      organization.expanded ? 'Icon-chevron-up' : 'Icon-chevron-down'
                    }`}></i>
                </div>
                {organization.expanded && (
                  <ul className="u-m-0 u-bg-grey-lighter">
                    {organization.communities.map((community, index) => {
                      return (
                        <li
                          key={community.slug}
                          className={`org-community-selector-list-item org-community-selector-list-item--community ${
                            community.active ? 'active' : ''
                          } ${index < organization.communities.length ? 'u-border-t' : ''} `}>
                          <a
                            href={community.url}
                            className="u-flex u-items-center u-flex-grow u-max-w-5/6 u-py-2">
                            <img
                              src={community.logo}
                              alt=""
                              className={'org-community-selector-list-item-logo'}
                            />
                            <div className="u-flex u-flex-col u-truncate">
                              <span className="org-community-selector-list-item-title">
                                {community.name}
                              </span>
                              <span className="org-community-selector-list-item-subtitle">
                                Community
                              </span>
                            </div>
                          </a>
                        </li>
                      );
                    })}
                    {organization.canAddCommunities && (
                      <li
                        key={`new-${organization.slug}-community`}
                        className="org-community-selector-list-item u-border-t">
                        <ModalTrigger
                          async={true}
                          modalWrapperClassName="create-community-modal"
                          triggerLabel="Create community"
                          triggerIcon="Icon Icon-plus-square"
                          triggerClassName="org-community-selector-create-community-trigger"
                          triggerIconClassName="u-text-lg u-ml-4 u-mr-4"
                          asyncUrl={`${this.props.newCommunityUrl}?organization_slug=${organization.slug}`}></ModalTrigger>
                      </li>
                    )}
                  </ul>
                )}
              </li>
            );
          })}
        </ul>
      </div>
    );
  }

  renderBackgroundShadow() {
    return <div onClick={this.handleClickOutside} className="org-community-selector-bg-shadow" />;
  }

  render() {
    return (
      <div className="org-community-selector">
        {this.renderTrigger()}
        {this.state.selectorExpanded && this.renderSelector()}
        {this.state.selectorExpanded && this.renderBackgroundShadow()}
      </div>
    );
  }
}

export default onClickOutside(OrgCommunitySelector);
